import { Injectable } from '@angular/core';
import { ItemGroup } from '../models/cost-item';
import { CommunicationManagerService } from '../services/communication-manager.service';

@Injectable({
  providedIn: 'root',
})
export class ItemGroupService {
  constructor(private cm: CommunicationManagerService) {}

  public getProjectItemGroups(
    projectId: string,
    teamOrLogistics: 'team'
  ) {
    return this.cm.get(`itemGroup/team`, [
      { headerName: 'projectId', headerValue: projectId },
    ]);
  }

  public getAllProjectItemGroups(projectId: string) {
    return this.cm.get(`itemGroup`, [
      { headerName: 'projectId', headerValue: projectId },
    ]);
  }

  public getItemGroupPositions(
    projectId: string,
    itemGroupType: 'team' | 'all'
  ) {
    let route = 'position/all';
    switch (itemGroupType) {
      case 'team':
        route += '/team';
        break;
      default:
        break;
    }
    return this.cm.get(route, [
      { headerName: 'projectId', headerValue: projectId },
    ]);
  }

  public createItemGroup(
    projectId: string,
    isTeam: boolean,
    department: string,
    name?: string
  ) {
    let payload = {};

    payload = { department: department, name: name };
    return this.cm.postAndGetJson(
      `itemGroup/${isTeam ? 'team' : 'logistic'}`,
      payload,
      [{ headerName: 'projectId', headerValue: projectId }]
    );
  }

  public updateItemGroup(projectId: string, department: ItemGroup) {
    const payload = {
      name: department.name,
      orderNumber: department.orderNumber,
    };
    return this.cm.put(`itemGroup/${department._id}`, payload, [
      { headerName: 'projectId', headerValue: projectId },
    ]);
  }

  public deleteItemGroup(projectId: string, departmentId: string) {
    return this.cm.delete(`itemGroup/${departmentId}`, [
      { headerName: 'projectId', headerValue: projectId },
    ]);
  }

  public updateItemGroupOrder(
    projectId: string,
    payload: Array<{ id: string; orderNumber: number }>
  ) {
    return this.cm.put(`itemGroup/multi`, payload, [
      { headerName: 'projectId', headerValue: projectId },
    ]);
  }
}
